var map = {
	"./about_page/image-000.jpg": 8293,
	"./about_page/image-001.jpg": 7112,
	"./arrow-left.svg": 871,
	"./arrow-right.svg": 1506,
	"./bookmark.svg": 736,
	"./digital-giftcard.svg": 3577,
	"./download.svg": 5984,
	"./fallback-image.png": 9197,
	"./featured_companies/bolig.png": 5895,
	"./featured_companies/elle.png": 4060,
	"./featured_companies/finansavisen.png": 1743,
	"./featured_companies/mat_vin.png": 6276,
	"./hero-pattern.svg": 9477,
	"./home_page/beach.svg": 8509,
	"./home_page/camera.svg": 3297,
	"./home_page/headphones.svg": 7789,
	"./home_page/like.svg": 1269,
	"./locales/da.svg": 2761,
	"./locales/nb.svg": 2620,
	"./logo-white.svg": 425,
	"./logo.svg": 5429,
	"./movie.svg": 1396,
	"./physical-giftcard.svg": 8076,
	"./quote.svg": 7780,
	"./reel_landing.gif": 3752,
	"./vipps.svg": 6170,
	"images/about_page/image-000.jpg": 8293,
	"images/about_page/image-001.jpg": 7112,
	"images/arrow-left.svg": 871,
	"images/arrow-right.svg": 1506,
	"images/bookmark.svg": 736,
	"images/digital-giftcard.svg": 3577,
	"images/download.svg": 5984,
	"images/fallback-image.png": 9197,
	"images/featured_companies/bolig.png": 5895,
	"images/featured_companies/elle.png": 4060,
	"images/featured_companies/finansavisen.png": 1743,
	"images/featured_companies/mat_vin.png": 6276,
	"images/hero-pattern.svg": 9477,
	"images/home_page/beach.svg": 8509,
	"images/home_page/camera.svg": 3297,
	"images/home_page/headphones.svg": 7789,
	"images/home_page/like.svg": 1269,
	"images/locales/da.svg": 2761,
	"images/locales/nb.svg": 2620,
	"images/logo-white.svg": 425,
	"images/logo.svg": 5429,
	"images/movie.svg": 1396,
	"images/physical-giftcard.svg": 8076,
	"images/quote.svg": 7780,
	"images/reel_landing.gif": 3752,
	"images/vipps.svg": 6170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4312;